/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/


jQuery(document).ready(function($){
  $('.product__image-container').slick({
    dots: true,
  	infinite: true
  });
})